import { useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { queriesStore } from "@/shared/api";
import { Button } from "@/shared/ui";

const buttonVariance = tv({
  slots: {
    container: "",
    button: "",
  },
  variants: {
    position: {
      header: {
        container: "hidden md:flex",
      },
      body: {
        container: "sticky bottom-0 -m-6 mt-0 p-6 py-5 md:hidden",
        button: "w-full",
      },
    },
  },
});
type ButtonVariance = VariantProps<typeof buttonVariance>;

export const EditProfileButton = ({ position = "body" }: ButtonVariance) => {
  const queryClient = useQueryClient();

  const { container, button } = buttonVariance({ position });

  const handleHoverEdit = () =>
    queryClient.ensureQueryData(queriesStore.location.options._ctx.state());

  return (
    <div className={container()}>
      <Button
        size="lg"
        asChild
        className={button()}
        onMouseEnter={handleHoverEdit}
      >
        <Link to={ROUTES.PROFILE.EDIT}>{t`Edit`}</Link>
      </Button>
    </div>
  );
};
